import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './theme-global.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Enable offline support via service worker
serviceWorkerRegistration.register();

reportWebVitals();
